module.exports = __webpack_public_path__ + "img/9-6.9962b993.png";